import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import KeyboardReturnIcon from "@material-ui/icons/KeyboardReturn";
import Box from "@material-ui/core/Box";
import Edimanagement from "../../EdiManagement/views/EdiManagement";
import Base from "../../../base/views/base";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileMedical } from "@fortawesome/free-solid-svg-icons";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import ChromeReaderModeIcon from "@material-ui/icons/ChromeReaderMode";
import ReturnAuthorization from "../../../InventoryManagement/SaleableReturn/views/ReturnAuthorization";
import CreditMemo from "../../../InventoryManagement/CreditMemo/views/CreditMemo";
import { CloudUpload } from "@material-ui/icons";
import UploadCatalog from "../../UploadCatalog/views/UploadCatalog";
import { useLocation } from "react-router-dom";

export function TabPanel(props) {
  const { children, value, index, ...other } = props;
  const classes = useStyles();
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && <Box className={classes.container}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    "aria-controls": `scrollable-force-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& .MuiPaper-root": {
      backgroundColor: "rgba(255,255,255,0.5)",
      backdropFilter: "blur(6px)",
      borderRadius: "15px",
      padding: "10px",
      marginTop: "1%",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: "5px",
    justifyContent: "space-between",
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(8px)",
  },
  formControl: {
    width: "20%",
  },
  form: {
    display: "flex",
    justifyContent: "space-between",
  },
  showpath: {
    padding: "0.5rem",
    marginRight: "1rem",
  },
  button: {
    marginRight: "1rem",
  },
  reconsile: {
    display: "flex",
    justifyContent: "flex-end",
  },
}));

const tabIndexToNameMap = {
  aims_edi: 0,
  upload_catalog: 1,
  return_authorization: 2,
  credit_memo: 3,
  otc: 4,
};

export default function AnalyticsDashboard() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tabValue = searchParams.get("tab");

    if (tabValue && tabIndexToNameMap[tabValue]) {
      setValue(Number(tabIndexToNameMap[tabValue]));
    }
  }, [location.search]);

  return (
    <div style={{ display: "flex" }}>
      <Base showBaseMenu={true} title="Upload">
        <div className={classes.root}>
          <AppBar style={{ marginTop: 50 }} position="static" color="default">
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="on"
              indicatorColor="primary"
              textColor="primary"
              aria-label="scrollable force tabs example"
            >
              <Tab
                label="Aims EDI"
                icon={<FontAwesomeIcon icon={faFileMedical} size="lg" />}
                {...a11yProps(0)}
              />
              <Tab
                label="Upload Catalog"
                icon={<CloudUpload />}
                {...a11yProps(1)}
              />
              <Tab
                label="Return Authorization"
                icon={<KeyboardReturnIcon />}
                {...a11yProps(2)}
              />
              <Tab
                label="Credit Memo"
                icon={<CreditCardIcon />}
                {...a11yProps(3)}
              />

              {/* <Tab
                label="POS"
                icon={<FormatIndentIncreaseIcon />}
                {...a11yProps(3)}
              /> */}
              <Tab
                label="OTC"
                icon={<ChromeReaderModeIcon />}
                {...a11yProps(4)}
              />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <Edimanagement />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <UploadCatalog />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <ReturnAuthorization />
          </TabPanel>
          <TabPanel value={value} index={3}>
            <CreditMemo />
          </TabPanel>
          {/* <TabPanel value={value} index={3}>
            Point of Sale Machine
          </TabPanel> */}
          <TabPanel value={value} index={4}>
            OTC
          </TabPanel>
          <TabPanel value={value} index={5}>
            Item Six
          </TabPanel>
          <TabPanel value={value} index={6}>
            Item Seven
          </TabPanel>
        </div>
      </Base>
    </div>
  );
}
